import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { TimelineMax, TweenMax, Elastic } from 'gsap/TweenMax';
import useUpdateEffect from 'react-use/lib/useUpdateEffect';

const AttackConfig = ({ play, ...rest }) => {
  const svgRef = useRef();
  const attacksRef = useRef([]);

  const timeline = useRef();

  useEffect(() => {
    TweenMax.set(svgRef.current, {
      visibility: 'visible',
    });

    const ease = Elastic.easeOut.config(1, 1);

    timeline.current = new TimelineMax({
      paused: !play,
    });

    timeline.current.staggerFrom(attacksRef.current, 1, {
      alpha: 0,
      y: '-=32px',
      stagger: 0.75,
      ease,
    });

    return () => {
      if (timeline.current) timeline.current.kill();
    };
  }, []);

  useUpdateEffect(() => {
    if (play) {
      timeline.current.play();
    }
  });

  const handleClick = () => {
    if (timeline.current) timeline.current.restart();
  };

  return (
    <svg
      className="product__scenarios-scaleSvg"
      ref={svgRef}
      onClick={handleClick}
      viewBox="0 0 403 597"
      {...rest}
    >
      <defs>
        <path id="AttackConfig__prefix__r" d="M0 0h345v142H0z" />
        <path
          id="AttackConfig__prefix__K"
          d="M22.502 7.083L11.686 21.667h9.086l-.325 1.979-1.838 9.27 10.816-14.583h-9.086l.325-1.979 1.838-9.27zM25.64 0l-3.245 16.667h10.384L15.472 40l3.245-16.667H8.333L25.64 0z"
        />
        <path
          id="AttackConfig__prefix__I"
          d="M11.732 15.598A3.332 3.332 0 018.4 12.266c0-1.244.678-2.333 1.666-2.9l10.786-6.242-6.143 10.641a3.34 3.34 0 01-2.977 1.833zM12 0c2.172 0 4.2.576 5.964 1.522l-2.52 1.394A9.945 9.945 0 0012 2.306c-5.302 0-9.6 4.128-9.6 9.221 0 2.548 1.068 4.853 2.808 6.513h.012c.468.45.468 1.176 0 1.625-.468.45-1.236.45-1.704.012C1.344 17.59 0 14.709 0 11.527 0 5.161 5.373 0 12 0zm12 11.527c0 3.182-1.344 6.063-3.516 8.15a1.242 1.242 0 01-1.692-.012 1.116 1.116 0 010-1.625c1.74-1.671 2.808-3.965 2.808-6.513a8.981 8.981 0 00-.648-3.343l1.452-2.42C23.4 7.493 24 9.429 24 11.527z"
        />
        <path
          id="AttackConfig__prefix__e"
          d="M20 91h345v464a5 5 0 01-5 5H20V91z"
        />
        <path
          id="AttackConfig__prefix__E"
          d="M14.157 4.667h-.313L4.667 9.276v8.317l9.144 5.74h.378l9.144-5.74V9.276l-9.177-4.61zm7.237 4.958l-2.975 1.494-3.306-1.66 2.975-1.494 3.306 1.66zM14.001 5.91l2.976 1.495L14 8.9l-2.975-1.494L14 5.91zM9.913 7.965l2.976 1.494-3.307 1.66-2.975-1.494 3.306-1.66zM8.5 18.593l-2.588-1.625v-2.827L8.5 15.657v2.936zm0-4.097L5.912 12.98v-2.382l2.588 1.3v2.598zm4.879 7.16l-3.83-2.403v-2.98l3.83 2.243v3.14zm0-4.3l-3.83-2.244v-2.686l3.83 1.922v3.007zm.622-4.018l-3.306-1.66L14 10.018l3.307 1.66L14 13.338zm4.452 5.915l-3.83 2.403v-3.14l3.83-2.244v2.98zm0-4.14l-3.83 2.243v-3.007l3.83-1.922v2.687-.002zm3.637 1.857l-2.587 1.623v-2.936l2.587-1.516V16.97zm0-3.989l-2.587 1.517V11.9l2.587-1.3v2.382-.001z"
        />
        <path id="AttackConfig__prefix__g" d="M0 0h345v129H0z" />
        <path id="AttackConfig__prefix__B" d="M0 0h345v122H0z" />
        <path
          id="AttackConfig__prefix__y"
          d="M14.157 4.667h-.313L4.667 9.276v8.317l9.144 5.74h.378l9.144-5.74V9.276l-9.177-4.61zm7.237 4.958l-2.975 1.494-3.306-1.66 2.975-1.494 3.306 1.66zM14.001 5.91l2.976 1.495L14 8.9l-2.975-1.494L14 5.91zM9.913 7.965l2.976 1.494-3.307 1.66-2.975-1.494 3.306-1.66zM8.5 18.593l-2.588-1.625v-2.827L8.5 15.657v2.936zm0-4.097L5.912 12.98v-2.382l2.588 1.3v2.598zm4.879 7.16l-3.83-2.403v-2.98l3.83 2.243v3.14zm0-4.3l-3.83-2.244v-2.686l3.83 1.922v3.007zm.622-4.018l-3.306-1.66L14 10.018l3.307 1.66L14 13.338zm4.452 5.915l-3.83 2.403v-3.14l3.83-2.244v2.98zm0-4.14l-3.83 2.243v-3.007l3.83-1.922v2.687-.002zm3.637 1.857l-2.587 1.623v-2.936l2.587-1.516V16.97zm0-3.989l-2.587 1.517V11.9l2.587-1.3v2.382-.001z"
        />
        <path
          id="AttackConfig__prefix__j"
          d="M11.732 15.598A3.332 3.332 0 018.4 12.266c0-1.244.678-2.333 1.666-2.9l10.786-6.242-6.143 10.641a3.34 3.34 0 01-2.977 1.833zM12 0c2.172 0 4.2.576 5.964 1.522l-2.52 1.394A9.945 9.945 0 0012 2.306c-5.302 0-9.6 4.128-9.6 9.221 0 2.548 1.068 4.853 2.808 6.513h.012c.468.45.468 1.176 0 1.625-.468.45-1.236.45-1.704.012C1.344 17.59 0 14.709 0 11.527 0 5.161 5.373 0 12 0zm12 11.527c0 3.182-1.344 6.063-3.516 8.15a1.242 1.242 0 01-1.692-.012 1.116 1.116 0 010-1.625c1.74-1.671 2.808-3.965 2.808-6.513a8.981 8.981 0 00-.648-3.343l1.452-2.42C23.4 7.493 24 9.429 24 11.527z"
        />
        <path
          id="AttackConfig__prefix__u"
          d="M11.732 15.598A3.332 3.332 0 018.4 12.266c0-1.244.678-2.333 1.666-2.9l10.786-6.242-6.143 10.641a3.34 3.34 0 01-2.977 1.833zM12 0c2.172 0 4.2.576 5.964 1.522l-2.52 1.394A9.945 9.945 0 0012 2.306c-5.302 0-9.6 4.128-9.6 9.221 0 2.548 1.068 4.853 2.808 6.513h.012c.468.45.468 1.176 0 1.625-.468.45-1.236.45-1.704.012C1.344 17.59 0 14.709 0 11.527 0 5.161 5.373 0 12 0zm12 11.527c0 3.182-1.344 6.063-3.516 8.15a1.242 1.242 0 01-1.692-.012 1.116 1.116 0 010-1.625c1.74-1.671 2.808-3.965 2.808-6.513a8.981 8.981 0 00-.648-3.343l1.452-2.42C23.4 7.493 24 9.429 24 11.527z"
        />
        <path
          id="AttackConfig__prefix__n"
          d="M14.157 4.667h-.313L4.667 9.276v8.317l9.144 5.74h.378l9.144-5.74V9.276l-9.177-4.61zm7.237 4.958l-2.975 1.494-3.306-1.66 2.975-1.494 3.306 1.66zM14.001 5.91l2.976 1.495L14 8.9l-2.975-1.494L14 5.91zM9.913 7.965l2.976 1.494-3.307 1.66-2.975-1.494 3.306-1.66zM8.5 18.593l-2.588-1.625v-2.827L8.5 15.657v2.936zm0-4.097L5.912 12.98v-2.382l2.588 1.3v2.598zm4.879 7.16l-3.83-2.403v-2.98l3.83 2.243v3.14zm0-4.3l-3.83-2.244v-2.686l3.83 1.922v3.007zm.622-4.018l-3.306-1.66L14 10.018l3.307 1.66L14 13.338zm4.452 5.915l-3.83 2.403v-3.14l3.83-2.244v2.98zm0-4.14l-3.83 2.243v-3.007l3.83-1.922v2.687-.002zm3.637 1.857l-2.587 1.623v-2.936l2.587-1.516V16.97zm0-3.989l-2.587 1.517V11.9l2.587-1.3v2.382-.001z"
        />
        <rect
          id="AttackConfig__prefix__b"
          width={365}
          height={559}
          x={0}
          y={1}
          rx={5}
        />
        <rect
          id="AttackConfig__prefix__s"
          width={40}
          height={40}
          x={0}
          y={0}
          rx={20}
        />
        <rect
          id="AttackConfig__prefix__l"
          width={40}
          height={40}
          x={0}
          y={0}
          rx={8}
        />
        <rect
          id="AttackConfig__prefix__w"
          width={40}
          height={40}
          x={0}
          y={0}
          rx={8}
        />
        <rect
          id="AttackConfig__prefix__h"
          width={40}
          height={40}
          x={0}
          y={0}
          rx={20}
        />
        <rect
          id="AttackConfig__prefix__C"
          width={40}
          height={40}
          x={0}
          y={0}
          rx={8}
        />
        <rect
          id="AttackConfig__prefix__G"
          width={40}
          height={40}
          x={0}
          y={0}
          rx={20}
        />
        <filter
          id="AttackConfig__prefix__A"
          width="100.3%"
          height="101.6%"
          x="-.1%"
          y="-.4%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            dy={1}
            in="SourceAlpha"
            result="AttackConfig__shadowOffsetOuter1"
          />
          <feColorMatrix
            in="AttackConfig__shadowOffsetOuter1"
            values="0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 1 0"
          />
        </filter>
        <filter
          id="AttackConfig__prefix__f"
          width="100.3%"
          height="101.6%"
          x="-.1%"
          y="-.4%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            dy={1}
            in="SourceAlpha"
            result="AttackConfig__shadowOffsetOuter1"
          />
          <feColorMatrix
            in="AttackConfig__shadowOffsetOuter1"
            values="0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 1 0"
          />
        </filter>
        <filter
          id="AttackConfig__prefix__d"
          width="100.6%"
          height="100.2%"
          x="-.4%"
          y="-.1%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            dx={-1}
            in="SourceAlpha"
            result="AttackConfig__shadowOffsetOuter1"
          />
          <feColorMatrix
            in="AttackConfig__shadowOffsetOuter1"
            values="0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 1 0"
          />
        </filter>
        <filter
          id="AttackConfig__prefix__q"
          width="100.3%"
          height="101.4%"
          x="-.1%"
          y="-.4%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            dy={1}
            in="SourceAlpha"
            result="AttackConfig__shadowOffsetOuter1"
          />
          <feColorMatrix
            in="AttackConfig__shadowOffsetOuter1"
            values="0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 1 0"
          />
        </filter>
        <filter
          id="AttackConfig__prefix__a"
          width="115.6%"
          height="110.2%"
          x="-7.8%"
          y="-5.1%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            in="SourceAlpha"
            result="AttackConfig__shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="AttackConfig__shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation={9.5}
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.504725743 0"
          />
        </filter>
        <linearGradient
          id="AttackConfig__prefix__p"
          x1="100%"
          x2="0%"
          y1="50%"
          y2="50%"
        >
          <stop offset="0%" stopColor="#E6E6E6" />
          <stop offset="49.134%" stopColor="#F2F2F2" />
          <stop offset="100%" stopColor="#E6E6E6" />
        </linearGradient>
        <linearGradient
          id="AttackConfig__prefix__c"
          x1="41.228%"
          x2="41.452%"
          y1="-99.743%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#FFF" />
          <stop offset="100%" stopColor="#E4E8F2" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(19 18)">
        <use
          fill="#000"
          filter="url(#AttackConfig__prefix__a)"
          xlinkHref="#AttackConfig__prefix__b"
        />
        <use
          fill="url(#AttackConfig__prefix__c)"
          xlinkHref="#AttackConfig__prefix__b"
        />
        <g transform="matrix(-1 0 0 1 385 0)">
          <use
            fill="#000"
            filter="url(#AttackConfig__prefix__d)"
            xlinkHref="#AttackConfig__prefix__e"
          />
          <use fill="#FFF" xlinkHref="#AttackConfig__prefix__e" />
        </g>
        <g
          ref={element => {
            attacksRef.current[2] = element;
          }}
          transform="translate(20 384)"
        >
          <use
            fill="#000"
            filter="url(#AttackConfig__prefix__f)"
            xlinkHref="#AttackConfig__prefix__g"
          />
          <use fill="#FFF" xlinkHref="#AttackConfig__prefix__g" />
          <path
            fill="#FFF"
            stroke="#CCC"
            d="M23 105h99a4 4 0 014 4v40a4 4 0 01-4 4H23a4 4 0 01-4-4v-40a4 4 0 014-4z"
          />
          <path
            fill="#373B46"
            fillRule="nonzero"
            d="M87.699 134v-8.73c-.623.446-1.78.856-2.754.996v-1.516c1.216-.25 2.41-.872 3.142-1.758h1.384V134H87.7z"
          />
          <path
            fill="#768599"
            fillRule="nonzero"
            d="M35.93 133v-8.073h2.69c1.681 0 2.729.408 3.395 1.16.585.661.929 1.639.929 2.831 0 1.23-.37 2.191-.93 2.841-.73.854-1.836 1.241-3.362 1.241H35.93zm1.299-1.074h1.493c1.058 0 1.783-.269 2.256-.822.446-.521.628-1.251.628-2.073 0-.908-.225-1.687-.666-2.208-.461-.542-1.165-.822-2.315-.822H37.23v5.925zm6.784-1.665c0-1.74.907-3.024 2.798-3.024 1.488 0 2.481.795 2.481 2.4 0 .29-.032.575-.08.839h-3.959c.054 1.03.554 1.75 1.67 1.75.742 0 1.252-.316 1.333-1.058l1.053.242c-.076 1.278-1.225 1.746-2.455 1.746-1.89 0-2.841-1.112-2.841-2.895zm1.262-.65h2.793c.005-.049.005-.097.005-.145 0-.784-.424-1.3-1.294-1.3-.935 0-1.391.59-1.504 1.445zm5.58 3.389v-8.073h1.204V133h-1.204zm2.557-1.515c0-1.444 1.461-1.777 2.643-1.777.45 0 .891.048 1.294.107v-.387c0-.73-.225-1.262-1.332-1.262-.585 0-1.117.15-1.117.763 0 .091.01.193.043.284l-1.15.06a1.375 1.375 0 01-.085-.5c0-1.074 1.025-1.536 2.395-1.536 1.692 0 2.45.703 2.45 2.095v2.486c0 .253.08.371.316.371.118 0 .285-.027.408-.064l.086.886a2.204 2.204 0 01-.805.145c-.495 0-1.058-.145-1.177-.956h-.021c-.355.548-1.026.956-1.966.956-1.069 0-1.982-.521-1.982-1.67zm1.235-.064c0 .585.414.816 1.005.816.967 0 1.638-.612 1.692-1.6a7.06 7.06 0 00-1.246-.118c-.752 0-1.45.145-1.45.902zm5.13 3.045c.306.113.666.199.972.199.559 0 .79-.35 1.031-.967l.231-.59-2.395-5.715h1.316l.972 2.46c.215.547.44 1.133.703 1.842h.022c.258-.73.43-1.193.671-1.821l.951-2.481h1.268l-2.675 6.585c-.446 1.095-1.01 1.643-2.068 1.643-.42 0-.827-.091-1.101-.193l.102-.962z"
          />
          <path
            fill="#3A3F4C"
            fillRule="nonzero"
            d="M94.18 134v-7.646h1.354l.066 1.047.03.007c.512-.871 1.435-1.267 2.519-1.267 1.157 0 2.065.454 2.454 1.333h.029c.52-.908 1.45-1.333 2.563-1.333 1.612 0 2.718.894 2.718 2.6V134h-1.641v-4.922c0-.989-.41-1.67-1.48-1.67-1.23 0-1.926.989-1.926 2.08V134h-1.64v-4.922c0-.989-.41-1.67-1.48-1.67-1.23 0-1.926.989-1.926 2.08V134h-1.64zM76.56 51h-7.264V39.656h2.208v9.232h5.056V51zm1.056-2.144c0-1.408 1.04-2.192 2.352-2.384l1.936-.288c.448-.064.592-.288.592-.56 0-.56-.432-1.024-1.328-1.024-.928 0-1.44.592-1.504 1.28l-1.888-.4c.128-1.232 1.264-2.592 3.376-2.592 2.496 0 3.424 1.408 3.424 2.992v3.872c0 .416.048.976.096 1.248H82.72c-.048-.208-.08-.64-.08-.944-.4.624-1.152 1.168-2.32 1.168-1.68 0-2.704-1.136-2.704-2.368zm3.152.784c.896 0 1.728-.432 1.728-1.824v-.352l-1.776.272c-.544.08-.976.384-.976.992 0 .464.336.912 1.024.912zm8.576-8.864v2.352h1.584v1.888h-1.584v3.296c0 .688.32.912.928.912.256 0 .544-.032.656-.064v1.76c-.192.08-.576.192-1.2.192-1.536 0-2.496-.912-2.496-2.432v-3.664h-1.424v-1.888h.4c.832 0 1.216-.544 1.216-1.248v-1.104h1.92zm4.896 5.392h3.52c-.032-.784-.544-1.552-1.76-1.552-1.104 0-1.712.832-1.76 1.552zm3.728 2.048l1.776.528c-.4 1.36-1.648 2.496-3.584 2.496-2.16 0-4.064-1.552-4.064-4.208 0-2.512 1.856-4.144 3.872-4.144 2.432 0 3.888 1.552 3.888 4.08 0 .304-.032.624-.032.656h-5.632c.048 1.04.928 1.792 1.984 1.792.992 0 1.536-.496 1.792-1.2zm5.696-1.744V51h-2.128v-7.872h2.064v.976c.48-.816 1.424-1.184 2.272-1.184 1.952 0 2.848 1.392 2.848 3.12V51h-2.128v-4.592c0-.88-.432-1.568-1.456-1.568-.928 0-1.472.72-1.472 1.632zm10.752-1.616c-1.088 0-2 .784-2 2.208 0 1.424.928 2.224 2.016 2.224s1.632-.72 1.808-1.328l1.872.624c-.352 1.312-1.584 2.656-3.68 2.656-2.32 0-4.144-1.76-4.144-4.176 0-2.432 1.792-4.176 4.08-4.176 2.144 0 3.36 1.328 3.696 2.656l-1.904.64c-.192-.656-.688-1.328-1.744-1.328zm7.984 9.248h-2.256L122 50.008l-3.344-6.88h2.384l2.096 4.608 1.936-4.608h2.272L122.4 54.104z"
          />
          <g transform="rotate(180 29.5 38)">
            <mask id="AttackConfig__prefix__i" fill="#fff">
              <use xlinkHref="#AttackConfig__prefix__h" />
            </mask>
            <g fill="#3A3F4C" mask="url(#AttackConfig__prefix__i)">
              <path d="M0 0h41v40H0z" />
            </g>
            <g transform="rotate(-180 16 16)">
              <mask id="AttackConfig__prefix__k" fill="#fff">
                <use xlinkHref="#AttackConfig__prefix__j" />
              </mask>
              <use
                fill="#E6E6E6"
                fillRule="nonzero"
                transform="matrix(-1 0 0 1 24 0)"
                xlinkHref="#AttackConfig__prefix__j"
              />
            </g>
          </g>
          <g transform="translate(171 36)">
            <mask id="AttackConfig__prefix__m" fill="#fff">
              <use xlinkHref="#AttackConfig__prefix__l" />
            </mask>
            <use fill="#D6DBDE" xlinkHref="#AttackConfig__prefix__l" />
            <g fill="#E6E6E6" mask="url(#AttackConfig__prefix__m)">
              <path d="M0 0h40v40H0z" />
            </g>
            <g transform="translate(6 6)">
              <mask id="AttackConfig__prefix__o" fill="#fff">
                <use xlinkHref="#AttackConfig__prefix__n" />
              </mask>
              <use
                fill="#60667C"
                fillRule="nonzero"
                xlinkHref="#AttackConfig__prefix__n"
              />
              <g fill="#3A3F4C" mask="url(#AttackConfig__prefix__o)">
                <path d="M0 0h28v28H0z" />
              </g>
            </g>
            <path
              fill="#3A3F4C"
              fillRule="nonzero"
              d="M61.184 16h-2.192V9.056h-2.496V7.568c1.52-.016 2.576-.864 2.784-1.952h1.904V16zm4.016-5.184c0 1.088.16 2.016.56 2.64.32.512.816.848 1.568.848.768 0 1.232-.336 1.552-.848.416-.624.576-1.552.576-2.64s-.16-2.016-.576-2.64c-.32-.512-.784-.848-1.552-.848-.752 0-1.248.336-1.568.848-.4.624-.56 1.552-.56 2.64zm-2.208 0c0-1.328.208-2.624.912-3.696.688-1.024 1.808-1.744 3.424-1.744 1.616 0 2.736.72 3.408 1.744.704 1.072.928 2.368.928 3.696 0 1.328-.224 2.624-.928 3.696-.672 1.024-1.792 1.744-3.408 1.744-1.616 0-2.736-.72-3.424-1.744-.704-1.072-.912-2.368-.912-3.696zm12.192 0c0 1.088.16 2.016.56 2.64.32.512.816.848 1.568.848.768 0 1.232-.336 1.552-.848.416-.624.576-1.552.576-2.64s-.16-2.016-.576-2.64c-.32-.512-.784-.848-1.552-.848-.752 0-1.248.336-1.568.848-.4.624-.56 1.552-.56 2.64zm-2.208 0c0-1.328.208-2.624.912-3.696.688-1.024 1.808-1.744 3.424-1.744 1.616 0 2.736.72 3.408 1.744.704 1.072.928 2.368.928 3.696 0 1.328-.224 2.624-.928 3.696-.672 1.024-1.792 1.744-3.408 1.744-1.616 0-2.736-.72-3.424-1.744-.704-1.072-.912-2.368-.912-3.696zm11.632-2.752c0 .672.464 1.12 1.056 1.12.608 0 1.056-.464 1.056-1.12 0-.656-.448-1.104-1.056-1.104-.592 0-1.056.448-1.056 1.104zm-1.6 0c0-1.472 1.216-2.624 2.656-2.624 1.44 0 2.672 1.152 2.672 2.624 0 1.488-1.232 2.608-2.672 2.608-1.456 0-2.656-1.152-2.656-2.608zm8.592 5.504c0 .672.464 1.12 1.056 1.12.608 0 1.056-.464 1.056-1.12 0-.656-.448-1.104-1.056-1.104-.592 0-1.056.448-1.056 1.104zm-1.6 0c0-1.472 1.216-2.624 2.656-2.624 1.44 0 2.672 1.152 2.672 2.624 0 1.488-1.232 2.608-2.672 2.608-1.456 0-2.656-1.152-2.656-2.608zM86.432 16h-1.856l7.328-10.384h1.856L86.432 16z"
            />
          </g>
          <rect
            width={78}
            height={8}
            x={71}
            y={64}
            fill="url(#AttackConfig__prefix__p)"
            rx={4}
          />
          <rect
            width={78}
            height={8}
            x={226}
            y={64}
            fill="url(#AttackConfig__prefix__p)"
            rx={4}
          />
        </g>
        <g
          ref={element => {
            attacksRef.current[1] = element;
          }}
          transform="translate(20 226)"
        >
          <use
            fill="#000"
            filter="url(#AttackConfig__prefix__q)"
            xlinkHref="#AttackConfig__prefix__r"
          />
          <use fill="#FFF" xlinkHref="#AttackConfig__prefix__r" />
          <path
            fill="#FFF"
            stroke="#CCC"
            d="M23 118h99a4 4 0 014 4v40a4 4 0 01-4 4H23a4 4 0 01-4-4v-40a4 4 0 014-4z"
          />
          <path
            fill="#373B46"
            fillRule="nonzero"
            d="M87.699 147v-8.73c-.623.446-1.78.856-2.754.996v-1.516c1.216-.25 2.41-.872 3.142-1.758h1.384V147H87.7z"
          />
          <path
            fill="#768599"
            fillRule="nonzero"
            d="M35.93 146v-8.073h2.69c1.681 0 2.729.408 3.395 1.16.585.661.929 1.639.929 2.831 0 1.23-.37 2.191-.93 2.841-.73.854-1.836 1.241-3.362 1.241H35.93zm1.299-1.074h1.493c1.058 0 1.783-.269 2.256-.822.446-.521.628-1.251.628-2.073 0-.908-.225-1.687-.666-2.208-.461-.542-1.165-.822-2.315-.822H37.23v5.925zm6.784-1.665c0-1.74.907-3.024 2.798-3.024 1.488 0 2.481.795 2.481 2.4 0 .29-.032.575-.08.839h-3.959c.054 1.03.554 1.75 1.67 1.75.742 0 1.252-.316 1.333-1.058l1.053.242c-.076 1.278-1.225 1.746-2.455 1.746-1.89 0-2.841-1.112-2.841-2.895zm1.262-.65h2.793c.005-.049.005-.097.005-.145 0-.784-.424-1.3-1.294-1.3-.935 0-1.391.59-1.504 1.445zm5.58 3.389v-8.073h1.204V146h-1.204zm2.557-1.515c0-1.444 1.461-1.777 2.643-1.777.45 0 .891.048 1.294.107v-.387c0-.73-.225-1.262-1.332-1.262-.585 0-1.117.15-1.117.763 0 .091.01.193.043.284l-1.15.06a1.375 1.375 0 01-.085-.5c0-1.074 1.025-1.536 2.395-1.536 1.692 0 2.45.703 2.45 2.095v2.486c0 .253.08.371.316.371.118 0 .285-.027.408-.064l.086.886a2.204 2.204 0 01-.805.145c-.495 0-1.058-.145-1.177-.956h-.021c-.355.548-1.026.956-1.966.956-1.069 0-1.982-.521-1.982-1.67zm1.235-.064c0 .585.414.816 1.005.816.967 0 1.638-.612 1.692-1.6a7.06 7.06 0 00-1.246-.118c-.752 0-1.45.145-1.45.902zm5.13 3.045c.306.113.666.199.972.199.559 0 .79-.35 1.031-.967l.231-.59-2.395-5.715h1.316l.972 2.46c.215.547.44 1.133.703 1.842h.022c.258-.73.43-1.193.671-1.821l.951-2.481h1.268l-2.675 6.585c-.446 1.095-1.01 1.643-2.068 1.643-.42 0-.827-.091-1.101-.193l.102-.962z"
          />
          <path
            fill="#3A3F4C"
            fillRule="nonzero"
            d="M94.18 147v-7.646h1.354l.066 1.047.03.007c.512-.871 1.435-1.267 2.519-1.267 1.157 0 2.065.454 2.454 1.333h.029c.52-.908 1.45-1.333 2.563-1.333 1.612 0 2.718.894 2.718 2.6V147h-1.641v-4.922c0-.989-.41-1.67-1.48-1.67-1.23 0-1.926.989-1.926 2.08V147h-1.64v-4.922c0-.989-.41-1.67-1.48-1.67-1.23 0-1.926.989-1.926 2.08V147h-1.64zM79.56 60h-7.264V48.656h2.208v9.232h5.056V60zm1.056-2.144c0-1.408 1.04-2.192 2.352-2.384l1.936-.288c.448-.064.592-.288.592-.56 0-.56-.432-1.024-1.328-1.024-.928 0-1.44.592-1.504 1.28l-1.888-.4c.128-1.232 1.264-2.592 3.376-2.592 2.496 0 3.424 1.408 3.424 2.992v3.872c0 .416.048.976.096 1.248H85.72c-.048-.208-.08-.64-.08-.944-.4.624-1.152 1.168-2.32 1.168-1.68 0-2.704-1.136-2.704-2.368zm3.152.784c.896 0 1.728-.432 1.728-1.824v-.352l-1.776.272c-.544.08-.976.384-.976.992 0 .464.336.912 1.024.912zm8.576-8.864v2.352h1.584v1.888h-1.584v3.296c0 .688.32.912.928.912.256 0 .544-.032.656-.064v1.76c-.192.08-.576.192-1.2.192-1.536 0-2.496-.912-2.496-2.432v-3.664h-1.424v-1.888h.4c.832 0 1.216-.544 1.216-1.248v-1.104h1.92zm4.896 5.392h3.52c-.032-.784-.544-1.552-1.76-1.552-1.104 0-1.712.832-1.76 1.552zm3.728 2.048l1.776.528c-.4 1.36-1.648 2.496-3.584 2.496-2.16 0-4.064-1.552-4.064-4.208 0-2.512 1.856-4.144 3.872-4.144 2.432 0 3.888 1.552 3.888 4.08 0 .304-.032.624-.032.656h-5.632c.048 1.04.928 1.792 1.984 1.792.992 0 1.536-.496 1.792-1.2zm5.696-1.744V60h-2.128v-7.872h2.064v.976c.48-.816 1.424-1.184 2.272-1.184 1.952 0 2.848 1.392 2.848 3.12V60h-2.128v-4.592c0-.88-.432-1.568-1.456-1.568-.928 0-1.472.72-1.472 1.632zm10.752-1.616c-1.088 0-2 .784-2 2.208 0 1.424.928 2.224 2.016 2.224s1.632-.72 1.808-1.328l1.872.624c-.352 1.312-1.584 2.656-3.68 2.656-2.32 0-4.144-1.76-4.144-4.176 0-2.432 1.792-4.176 4.08-4.176 2.144 0 3.36 1.328 3.696 2.656l-1.904.64c-.192-.656-.688-1.328-1.744-1.328zm7.984 9.248h-2.256L125 59.008l-3.344-6.88h2.384l2.096 4.608 1.936-4.608h2.272L125.4 63.104z"
          />
          <g transform="rotate(180 29.5 42)">
            <mask id="AttackConfig__prefix__t" fill="#fff">
              <use xlinkHref="#AttackConfig__prefix__s" />
            </mask>
            <g fill="#3A3F4C" mask="url(#AttackConfig__prefix__t)">
              <path d="M0 0h41v40H0z" />
            </g>
            <g transform="rotate(-180 16 16)">
              <mask id="AttackConfig__prefix__v" fill="#fff">
                <use xlinkHref="#AttackConfig__prefix__u" />
              </mask>
              <use
                fill="#E6E6E6"
                fillRule="nonzero"
                transform="matrix(-1 0 0 1 24 0)"
                xlinkHref="#AttackConfig__prefix__u"
              />
            </g>
          </g>
          <g transform="translate(171 44)">
            <mask id="AttackConfig__prefix__x" fill="#fff">
              <use xlinkHref="#AttackConfig__prefix__w" />
            </mask>
            <use fill="#D6DBDE" xlinkHref="#AttackConfig__prefix__w" />
            <g fill="#E6E6E6" mask="url(#AttackConfig__prefix__x)">
              <path d="M0 0h40v40H0z" />
            </g>
            <g transform="translate(6 6)">
              <mask id="AttackConfig__prefix__z" fill="#fff">
                <use xlinkHref="#AttackConfig__prefix__y" />
              </mask>
              <use
                fill="#60667C"
                fillRule="nonzero"
                xlinkHref="#AttackConfig__prefix__y"
              />
              <g fill="#3A3F4C" mask="url(#AttackConfig__prefix__z)">
                <path d="M0 0h28v28H0z" />
              </g>
            </g>
            <path
              fill="#3A3F4C"
              fillRule="nonzero"
              d="M56.464 13.088l2.064-.464c.048.96.784 1.744 1.888 1.744.992 0 1.792-.656 1.792-1.696 0-1.184-.88-1.744-1.84-1.744a2.12 2.12 0 00-1.6.704 74.475 74.475 0 00-2.016-.688l1.232-5.328h5.856V7.52h-4.352l-.512 2.288c.448-.416 1.184-.64 1.872-.64 2.08 0 3.552 1.248 3.552 3.472 0 1.936-1.488 3.616-3.984 3.616-2.256 0-3.824-1.536-3.952-3.168zm11.264-2.272c0 1.088.16 2.016.56 2.64.32.512.816.848 1.568.848.768 0 1.232-.336 1.552-.848.416-.624.576-1.552.576-2.64s-.16-2.016-.576-2.64c-.32-.512-.784-.848-1.552-.848-.752 0-1.248.336-1.568.848-.4.624-.56 1.552-.56 2.64zm-2.208 0c0-1.328.208-2.624.912-3.696.688-1.024 1.808-1.744 3.424-1.744 1.616 0 2.736.72 3.408 1.744.704 1.072.928 2.368.928 3.696 0 1.328-.224 2.624-.928 3.696-.672 1.024-1.792 1.744-3.408 1.744-1.616 0-2.736-.72-3.424-1.744-.704-1.072-.912-2.368-.912-3.696zm11.632-2.752c0 .672.464 1.12 1.056 1.12.608 0 1.056-.464 1.056-1.12 0-.656-.448-1.104-1.056-1.104-.592 0-1.056.448-1.056 1.104zm-1.6 0c0-1.472 1.216-2.624 2.656-2.624 1.44 0 2.672 1.152 2.672 2.624 0 1.488-1.232 2.608-2.672 2.608-1.456 0-2.656-1.152-2.656-2.608zm8.592 5.504c0 .672.464 1.12 1.056 1.12.608 0 1.056-.464 1.056-1.12 0-.656-.448-1.104-1.056-1.104-.592 0-1.056.448-1.056 1.104zm-1.6 0c0-1.472 1.216-2.624 2.656-2.624 1.44 0 2.672 1.152 2.672 2.624 0 1.488-1.232 2.608-2.672 2.608-1.456 0-2.656-1.152-2.656-2.608zM78.976 16H77.12l7.328-10.384h1.856L78.976 16z"
            />
          </g>
          <rect
            width={78}
            height={8}
            x={71}
            y={73}
            fill="url(#AttackConfig__prefix__p)"
            rx={4}
          />
          <rect
            width={78}
            height={8}
            x={226}
            y={73}
            fill="url(#AttackConfig__prefix__p)"
            rx={4}
          />
        </g>
        <g
          ref={element => {
            attacksRef.current[0] = element;
          }}
          transform="translate(20 97)"
        >
          <use
            fill="#000"
            filter="url(#AttackConfig__prefix__A)"
            xlinkHref="#AttackConfig__prefix__B"
          />
          <use fill="#FFF" xlinkHref="#AttackConfig__prefix__B" />
          <path
            fill="#FFF"
            stroke="#CCC"
            d="M23 98h99a4 4 0 014 4v40a4 4 0 01-4 4H23a4 4 0 01-4-4v-40a4 4 0 014-4z"
          />
          <path
            fill="#373B46"
            fillRule="nonzero"
            d="M87.699 127v-8.73c-.623.446-1.78.856-2.754.996v-1.516c1.216-.25 2.41-.872 3.142-1.758h1.384V127H87.7z"
          />
          <path
            fill="#768599"
            fillRule="nonzero"
            d="M35.93 126v-8.073h2.69c1.681 0 2.729.408 3.395 1.16.585.661.929 1.639.929 2.831 0 1.23-.37 2.191-.93 2.841-.73.854-1.836 1.241-3.362 1.241H35.93zm1.299-1.074h1.493c1.058 0 1.783-.269 2.256-.822.446-.521.628-1.251.628-2.073 0-.908-.225-1.687-.666-2.208-.461-.542-1.165-.822-2.315-.822H37.23v5.925zm6.784-1.665c0-1.74.907-3.024 2.798-3.024 1.488 0 2.481.795 2.481 2.4 0 .29-.032.575-.08.839h-3.959c.054 1.03.554 1.75 1.67 1.75.742 0 1.252-.316 1.333-1.058l1.053.242c-.076 1.278-1.225 1.746-2.455 1.746-1.89 0-2.841-1.112-2.841-2.895zm1.262-.65h2.793c.005-.048.005-.097.005-.145 0-.784-.424-1.3-1.294-1.3-.935 0-1.391.59-1.504 1.445zm5.58 3.389v-8.073h1.204V126h-1.204zm2.557-1.515c0-1.444 1.461-1.777 2.643-1.777.45 0 .891.048 1.294.107v-.387c0-.73-.225-1.262-1.332-1.262-.585 0-1.117.15-1.117.763 0 .091.01.193.043.284l-1.15.06a1.375 1.375 0 01-.085-.5c0-1.074 1.025-1.536 2.395-1.536 1.692 0 2.45.703 2.45 2.095v2.486c0 .253.08.371.316.371.118 0 .285-.027.408-.064l.086.886a2.204 2.204 0 01-.805.145c-.495 0-1.058-.145-1.177-.956h-.021c-.355.548-1.026.956-1.966.956-1.069 0-1.982-.521-1.982-1.67zm1.235-.064c0 .585.414.816 1.005.816.967 0 1.638-.612 1.692-1.6a7.06 7.06 0 00-1.246-.118c-.752 0-1.45.145-1.45.902zm5.13 3.045c.306.113.666.199.972.199.559 0 .79-.35 1.031-.967l.231-.59-2.395-5.715h1.316l.972 2.46c.215.547.44 1.133.703 1.842h.022c.258-.73.43-1.193.671-1.821l.951-2.481h1.268l-2.675 6.585c-.446 1.095-1.01 1.643-2.068 1.643-.42 0-.827-.091-1.101-.193l.102-.962z"
          />
          <path
            fill="#3A3F4C"
            fillRule="nonzero"
            d="M94.18 127v-7.646h1.354l.066 1.047.03.007c.512-.871 1.435-1.267 2.519-1.267 1.157 0 2.065.454 2.454 1.333h.029c.52-.908 1.45-1.333 2.563-1.333 1.612 0 2.718.894 2.718 2.6V127h-1.641v-4.922c0-.989-.41-1.67-1.48-1.67-1.23 0-1.926.989-1.926 2.08V127h-1.64v-4.922c0-.989-.41-1.67-1.48-1.67-1.23 0-1.926.989-1.926 2.08V127h-1.64z"
          />
          <g transform="translate(171 31)">
            <mask id="AttackConfig__prefix__D" fill="#fff">
              <use xlinkHref="#AttackConfig__prefix__C" />
            </mask>
            <use fill="#D6DBDE" xlinkHref="#AttackConfig__prefix__C" />
            <g fill="#E6E6E6" mask="url(#AttackConfig__prefix__D)">
              <path d="M0 0h40v40H0z" />
            </g>
            <g transform="translate(6 6)">
              <mask id="AttackConfig__prefix__F" fill="#fff">
                <use xlinkHref="#AttackConfig__prefix__E" />
              </mask>
              <use
                fill="#60667C"
                fillRule="nonzero"
                xlinkHref="#AttackConfig__prefix__E"
              />
              <g fill="#3A3F4C" mask="url(#AttackConfig__prefix__F)">
                <path d="M0 0h28v28H0z" />
              </g>
            </g>
            <path
              fill="#3A3F4C"
              fillRule="nonzero"
              d="M60.184 16h-2.192V9.056h-2.496V7.568c1.52-.016 2.576-.864 2.784-1.952h1.904V16zm4.016-5.184c0 1.088.16 2.016.56 2.64.32.512.816.848 1.568.848.768 0 1.232-.336 1.552-.848.416-.624.576-1.552.576-2.64s-.16-2.016-.576-2.64c-.32-.512-.784-.848-1.552-.848-.752 0-1.248.336-1.568.848-.4.624-.56 1.552-.56 2.64zm-2.208 0c0-1.328.208-2.624.912-3.696.688-1.024 1.808-1.744 3.424-1.744 1.616 0 2.736.72 3.408 1.744.704 1.072.928 2.368.928 3.696 0 1.328-.224 2.624-.928 3.696-.672 1.024-1.792 1.744-3.408 1.744-1.616 0-2.736-.72-3.424-1.744-.704-1.072-.912-2.368-.912-3.696zm11.632-2.752c0 .672.464 1.12 1.056 1.12.608 0 1.056-.464 1.056-1.12 0-.656-.448-1.104-1.056-1.104-.592 0-1.056.448-1.056 1.104zm-1.6 0c0-1.472 1.216-2.624 2.656-2.624 1.44 0 2.672 1.152 2.672 2.624 0 1.488-1.232 2.608-2.672 2.608-1.456 0-2.656-1.152-2.656-2.608zm8.592 5.504c0 .672.464 1.12 1.056 1.12.608 0 1.056-.464 1.056-1.12 0-.656-.448-1.104-1.056-1.104-.592 0-1.056.448-1.056 1.104zm-1.6 0c0-1.472 1.216-2.624 2.656-2.624 1.44 0 2.672 1.152 2.672 2.624 0 1.488-1.232 2.608-2.672 2.608-1.456 0-2.656-1.152-2.656-2.608zM75.448 16h-1.856L80.92 5.616h1.856L75.448 16z"
            />
          </g>
          <g>
            <path
              fill="#3A3F4C"
              fillRule="nonzero"
              d="M79.56 47h-7.264V35.656h2.208v9.232h5.056V47zm1.056-2.144c0-1.408 1.04-2.192 2.352-2.384l1.936-.288c.448-.064.592-.288.592-.56 0-.56-.432-1.024-1.328-1.024-.928 0-1.44.592-1.504 1.28l-1.888-.4c.128-1.232 1.264-2.592 3.376-2.592 2.496 0 3.424 1.408 3.424 2.992v3.872c0 .416.048.976.096 1.248H85.72c-.048-.208-.08-.64-.08-.944-.4.624-1.152 1.168-2.32 1.168-1.68 0-2.704-1.136-2.704-2.368zm3.152.784c.896 0 1.728-.432 1.728-1.824v-.352l-1.776.272c-.544.08-.976.384-.976.992 0 .464.336.912 1.024.912zm8.576-8.864v2.352h1.584v1.888h-1.584v3.296c0 .688.32.912.928.912.256 0 .544-.032.656-.064v1.76c-.192.08-.576.192-1.2.192-1.536 0-2.496-.912-2.496-2.432v-3.664h-1.424v-1.888h.4c.832 0 1.216-.544 1.216-1.248v-1.104h1.92zm4.896 5.392h3.52c-.032-.784-.544-1.552-1.76-1.552-1.104 0-1.712.832-1.76 1.552zm3.728 2.048l1.776.528c-.4 1.36-1.648 2.496-3.584 2.496-2.16 0-4.064-1.552-4.064-4.208 0-2.512 1.856-4.144 3.872-4.144 2.432 0 3.888 1.552 3.888 4.08 0 .304-.032.624-.032.656h-5.632c.048 1.04.928 1.792 1.984 1.792.992 0 1.536-.496 1.792-1.2zm5.696-1.744V47h-2.128v-7.872h2.064v.976c.48-.816 1.424-1.184 2.272-1.184 1.952 0 2.848 1.392 2.848 3.12V47h-2.128v-4.592c0-.88-.432-1.568-1.456-1.568-.928 0-1.472.72-1.472 1.632zm10.752-1.616c-1.088 0-2 .784-2 2.208 0 1.424.928 2.224 2.016 2.224s1.632-.72 1.808-1.328l1.872.624c-.352 1.312-1.584 2.656-3.68 2.656-2.32 0-4.144-1.76-4.144-4.176 0-2.432 1.792-4.176 4.08-4.176 2.144 0 3.36 1.328 3.696 2.656l-1.904.64c-.192-.656-.688-1.328-1.744-1.328zm7.984 9.248h-2.256L125 46.008l-3.344-6.88h2.384l2.096 4.608 1.936-4.608h2.272L125.4 50.104z"
            />
            <g transform="rotate(180 29.5 35.5)">
              <mask id="AttackConfig__prefix__H" fill="#fff">
                <use xlinkHref="#AttackConfig__prefix__G" />
              </mask>
              <g fill="#3A3F4C" mask="url(#AttackConfig__prefix__H)">
                <path d="M0 0h41v40H0z" />
              </g>
              <g transform="rotate(-180 16 16)">
                <mask id="AttackConfig__prefix__J" fill="#fff">
                  <use xlinkHref="#AttackConfig__prefix__I" />
                </mask>
                <use
                  fill="#E6E6E6"
                  fillRule="nonzero"
                  transform="matrix(-1 0 0 1 24 0)"
                  xlinkHref="#AttackConfig__prefix__I"
                />
              </g>
            </g>
          </g>
          <rect
            width={78}
            height={8}
            x={71}
            y={58}
            fill="url(#AttackConfig__prefix__p)"
            rx={4}
          />
          <rect
            width={78}
            height={8}
            x={226}
            y={58}
            fill="url(#AttackConfig__prefix__p)"
            rx={4}
          />
        </g>
        <g transform="translate(20)">
          <path
            fill="#F8F8F8"
            stroke="#E6E6E6"
            d="M4-.5h337a4.5 4.5 0 014.5 4.5v92.5H-.5V4A4.5 4.5 0 014-.5z"
          />
          <path
            fill="#3A3F4C"
            fillRule="nonzero"
            d="M84.992 43l-.944-2.592H79.44L78.496 43H76.16l4.352-11.344h2.56L87.392 43h-2.4zm-3.248-8.896l-1.568 4.288h3.136l-1.568-4.288zm9.568-1.328v2.352h1.584v1.888h-1.584v3.296c0 .688.32.912.928.912.256 0 .544-.032.656-.064v1.76c-.192.08-.576.192-1.2.192-1.536 0-2.496-.912-2.496-2.432v-3.664h-1.424v-1.888h.4c.832 0 1.216-.544 1.216-1.248v-1.104h1.92zm5.968 0v2.352h1.584v1.888H97.28v3.296c0 .688.32.912.928.912.256 0 .544-.032.656-.064v1.76c-.192.08-.576.192-1.2.192-1.536 0-2.496-.912-2.496-2.432v-3.664h-1.424v-1.888h.4c.832 0 1.216-.544 1.216-1.248v-1.104h1.92zm2.864 8.08c0-1.408 1.04-2.192 2.352-2.384l1.936-.288c.448-.064.592-.288.592-.56 0-.56-.432-1.024-1.328-1.024-.928 0-1.44.592-1.504 1.28l-1.888-.4c.128-1.232 1.264-2.592 3.376-2.592 2.496 0 3.424 1.408 3.424 2.992v3.872c0 .416.048.976.096 1.248h-1.952c-.048-.208-.08-.64-.08-.944-.4.624-1.152 1.168-2.32 1.168-1.68 0-2.704-1.136-2.704-2.368zm3.152.784c.896 0 1.728-.432 1.728-1.824v-.352l-1.776.272c-.544.08-.976.384-.976.992 0 .464.336.912 1.024.912zm9.488-4.784c-1.088 0-2 .784-2 2.208 0 1.424.928 2.224 2.016 2.224s1.632-.72 1.808-1.328l1.872.624c-.352 1.312-1.584 2.656-3.68 2.656-2.32 0-4.144-1.76-4.144-4.176 0-2.432 1.792-4.176 4.08-4.176 2.144 0 3.36 1.328 3.696 2.656l-1.904.64c-.192-.656-.688-1.328-1.744-1.328zm12.896-1.728l-3.152 3.312 3.216 4.56h-2.608l-2.08-3.008-.88.928V43h-2.128V31.416h2.128v6.64l2.72-2.928h2.784zm8.8 1.728c-1.088 0-2 .784-2 2.208 0 1.424.928 2.224 2.016 2.224s1.632-.72 1.808-1.328l1.872.624c-.352 1.312-1.584 2.656-3.68 2.656-2.32 0-4.144-1.76-4.144-4.176 0-2.432 1.792-4.176 4.08-4.176 2.144 0 3.36 1.328 3.696 2.656l-1.904.64c-.192-.656-.688-1.328-1.744-1.328zm8.8 4.448c1.04 0 2-.752 2-2.24 0-1.488-.96-2.24-2-2.24s-2 .752-2 2.24c0 1.472.96 2.24 2 2.24zm0-6.416c2.352 0 4.128 1.744 4.128 4.176 0 2.416-1.776 4.176-4.128 4.176-2.352 0-4.128-1.76-4.128-4.176 0-2.432 1.776-4.176 4.128-4.176zm7.936 3.584V43h-2.128v-7.872h2.064v.976c.48-.816 1.424-1.184 2.272-1.184 1.952 0 2.848 1.392 2.848 3.12V43h-2.128v-4.592c0-.88-.432-1.568-1.456-1.568-.928 0-1.472.72-1.472 1.632zm12.912-1.52h-3.152V43h-2.144v-6.048h-1.312v-1.824h1.312v-.896c0-1.776 1.12-2.928 2.864-2.928.448 0 .88.08 1.056.16v1.792a2.38 2.38 0 00-.672-.08c-.464 0-1.104.208-1.104 1.088v.864h5.264V43h-2.112v-6.048zm-.256-4.416c0-.736.592-1.328 1.312-1.328.72 0 1.312.592 1.312 1.328 0 .72-.592 1.296-1.312 1.296-.72 0-1.312-.576-1.312-1.296zm4.096 10.896l1.92-.512c.144.864.832 1.488 1.84 1.488 1.344 0 2.096-.672 2.096-2.192v-.576c-.32.512-1.056 1.008-2.192 1.008-2.096 0-3.664-1.616-3.664-3.824 0-2.08 1.504-3.84 3.664-3.84 1.248 0 1.968.544 2.24 1.072v-.928h2.048v7.024c0 2.16-1.168 4.128-4.128 4.128-2.16 0-3.6-1.344-3.824-2.848zM172 40.824c1.088 0 1.856-.784 1.856-2s-.832-1.984-1.856-1.984c-1.056 0-1.888.768-1.888 1.984 0 1.232.784 2 1.888 2zM183.232 43a5.388 5.388 0 01-.064-.848c-.432.736-1.344 1.056-2.176 1.056-1.904 0-2.992-1.392-2.992-3.104v-4.976h2.128v4.544c0 .88.448 1.584 1.44 1.584.944 0 1.488-.64 1.488-1.552v-4.576h2.128v6.448c0 .608.048 1.152.08 1.424h-2.032zm9.024-7.904v2.144a3.204 3.204 0 00-.64-.064c-1.088 0-2.032.528-2.032 2.224V43h-2.128v-7.872h2.064v1.168c.48-1.04 1.568-1.232 2.24-1.232.176 0 .336.016.496.032zm.976 5.76c0-1.408 1.04-2.192 2.352-2.384l1.936-.288c.448-.064.592-.288.592-.56 0-.56-.432-1.024-1.328-1.024-.928 0-1.44.592-1.504 1.28l-1.888-.4c.128-1.232 1.264-2.592 3.376-2.592 2.496 0 3.424 1.408 3.424 2.992v3.872c0 .416.048.976.096 1.248h-1.952c-.048-.208-.08-.64-.08-.944-.4.624-1.152 1.168-2.32 1.168-1.68 0-2.704-1.136-2.704-2.368zm3.152.784c.896 0 1.728-.432 1.728-1.824v-.352l-1.776.272c-.544.08-.976.384-.976.992 0 .464.336.912 1.024.912zm8.576-8.864v2.352h1.584v1.888h-1.584v3.296c0 .688.32.912.928.912.256 0 .544-.032.656-.064v1.76c-.192.08-.576.192-1.2.192-1.536 0-2.496-.912-2.496-2.432v-3.664h-1.424v-1.888h.4c.832 0 1.216-.544 1.216-1.248v-1.104h1.92zM210.432 43h-2.128v-7.872h2.128V43zm-2.384-10.448c0-.736.592-1.328 1.312-1.328.736 0 1.312.592 1.312 1.328 0 .704-.576 1.296-1.312 1.296-.72 0-1.312-.592-1.312-1.296zm8.192 8.752c1.04 0 2-.752 2-2.24 0-1.488-.96-2.24-2-2.24s-2 .752-2 2.24c0 1.472.96 2.24 2 2.24zm0-6.416c2.352 0 4.128 1.744 4.128 4.176 0 2.416-1.776 4.176-4.128 4.176-2.352 0-4.128-1.76-4.128-4.176 0-2.432 1.776-4.176 4.128-4.176zm7.936 3.584V43h-2.128v-7.872h2.064v.976c.48-.816 1.424-1.184 2.272-1.184 1.952 0 2.848 1.392 2.848 3.12V43h-2.128v-4.592c0-.88-.432-1.568-1.456-1.568-.928 0-1.472.72-1.472 1.632z"
          />
          <g transform="translate(24 25)">
            <mask id="AttackConfig__prefix__L" fill="#fff">
              <use xlinkHref="#AttackConfig__prefix__K" />
            </mask>
            <use fill="#23C386" xlinkHref="#AttackConfig__prefix__K" />
            <g fill="#23C386" mask="url(#AttackConfig__prefix__L)">
              <path d="M0 0h40v40H0z" />
            </g>
          </g>
          <rect
            width={140}
            height={8}
            x={76}
            y={53}
            fill="#8899AE"
            opacity={0.401}
            rx={4}
          />
        </g>
      </g>
    </svg>
  );
};

AttackConfig.propTypes = {
  play: PropTypes.bool,
};

export default AttackConfig;
